export default {
    getModelCarpeta: (state) => {
        return state.carpeta
    }
}